module.exports = __webpack_public_path__ + "static/media/person.e5f4efb8.png";